/** 表示順でアンカーと対象の間にあるチャット ID を返す。どちらかが見えていなければ対象だけを返す。 */
export function resolveChatRange(
	visibleChatIds: readonly string[],
	anchorChatId: string | null,
	targetChatId: string,
): string[] {
	const targetIndex = visibleChatIds.indexOf(targetChatId);
	if (targetIndex < 0) return [];
	const anchorIndex = anchorChatId === null ? -1 : visibleChatIds.indexOf(anchorChatId);
	if (anchorIndex < 0) return [targetChatId];
	return visibleChatIds.slice(
		Math.min(anchorIndex, targetIndex),
		Math.max(anchorIndex, targetIndex) + 1,
	);
}
